import { parsePhoneNumberFromString } from "libphonenumber-js";

// Formats a support/contact phone number for display using the country's
// conventional grouping (e.g. "+1" + "7323255517" -> "+1 732 325 5517")
// instead of just concatenating the raw country code and digits.
// Falls back to the raw "countryCode phone" string if the number can't be
// parsed for that country.
export const formatPhoneNumber = (countryCode, phone) => {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  const parsed = parsePhoneNumberFromString(`${countryCode}${digits}`);
  return parsed ? parsed.formatInternational() : `${countryCode} ${phone}`;
};
